var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"axisHolder",staticClass:"c-conductor-axis",on:{"mousedown":function($event){_vm.dragStart($event)}}},[_c('div',{staticClass:"c-conductor-axis__zoom-indicator",style:(_vm.zoomStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }